import moment from 'moment';

export const URL_DATE_FORMAT = 'YYYY-MM-DD';
export const DISPLAY_DATE_FORMAT = 'MM.DD.YYYY';

export const defaultStartDate = moment().subtract(7, 'days');
export const defaultEndDate = moment();

export const toDisplayDateAndTime = (date?: string): string => {
  if (date) {
    const dateFormatSetting = localStorage.getItem('dateFormat');
    const displayDateFormat = dateFormatSetting
      ? dateFormatSetting
      : DISPLAY_DATE_FORMAT;
    return moment(date).format(displayDateFormat + ' HH:mm:ss');
  }
  return '';
};

export const toDisplayDate = (date?: string): string => {
  if (date) {
    const dateFormatSetting = localStorage.getItem('dateFormat');
    const displayDateFormat = dateFormatSetting
      ? dateFormatSetting
      : DISPLAY_DATE_FORMAT;
    return moment(date).format(displayDateFormat);
  }
  return '';
};

export const toDisplayTime = (date?: string): string => {
  if (date) {
    return moment(date).format('HH:mm:ss');
  }
  return '';
};
